"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polling = void 0;
const constants_1 = require("../constants");
class Polling {
    constructor(getDataFn, sendDataFn, interval = constants_1.DEFAULT_INTERVAL, maxAttempts = constants_1.DEFAULT_MAX_ATTEMPTS) {
        this.eventsCallback = {
            onError: (_error) => null,
            onReceiveData: (_data) => null,
        };
        this.getDataFn = getDataFn;
        this.sendDataFn = sendDataFn;
        this.interval = interval;
        this.maxAttempts = maxAttempts;
    }
    notifyConnect() {
        var _a, _b;
        (_b = (_a = this.eventsCallback) === null || _a === void 0 ? void 0 : _a.onConnect) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    notifyDisconnect() {
        var _a, _b;
        (_b = (_a = this.eventsCallback) === null || _a === void 0 ? void 0 : _a.onDisconnect) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    notifyReceiveData(data) {
        this.eventsCallback.onReceiveData(data);
    }
    notifyError(error) {
        this.eventsCallback.onError(error);
    }
    getData(currentAttempts) {
        if (currentAttempts > this.maxAttempts) {
            this.notifyError(new Error(constants_1.ERROR_MESSAGES_POLLING.MAX_ATTEMPTS_EXCEEDED));
            this.disconnect();
        }
        this.getDataFn()
            .then(response => {
            this.notifyReceiveData(response);
        })
            .catch(error => {
            this.notifyError(error);
        });
    }
    connect() {
        return new Promise((resolve, reject) => {
            if (!this.timer) {
                try {
                    let currentAttempts = 1;
                    this.timer = setInterval(() => {
                        this.getData(currentAttempts);
                        currentAttempts++;
                    }, this.interval);
                    this.notifyConnect();
                    resolve();
                }
                catch (error) {
                    reject(error);
                }
            }
            else {
                reject(new Error(constants_1.ERROR_MESSAGES_POLLING.CONNECTION_ALREADY_OPEN));
            }
        });
    }
    disconnect() {
        return new Promise((resolve, reject) => {
            if (this.timer) {
                try {
                    if (this.timer) {
                        clearInterval(this.timer);
                    }
                    this.notifyDisconnect();
                    resolve();
                }
                catch (error) {
                    reject(error);
                }
            }
            else {
                reject(new Error(constants_1.ERROR_MESSAGES_POLLING.CONNECTION_ALREADY_CLOSED));
            }
        });
    }
    send(data) {
        if (this.timer && this.sendDataFn) {
            this.sendDataFn(data)
                .then(response => {
                this.notifyReceiveData(response);
            })
                .catch(error => {
                this.notifyError(error);
            });
        }
        else {
            this.notifyError(new Error(constants_1.ERROR_MESSAGES_POLLING.CONNECTION_NOT_OPEN));
        }
    }
    listen(eventsCallback) {
        this.eventsCallback = Object.assign(Object.assign({}, this.eventsCallback), eventsCallback);
    }
}
exports.Polling = Polling;
//# sourceMappingURL=index.js.map